var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDeviceManage = function SvgDeviceManage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.25 5.5H16.75C16.0469 5.5 15.5 6.08594 15.5 6.75V19.25C15.5 19.9531 16.0469 20.5 16.75 20.5H24.25C24.9141 20.5 25.5 19.9531 25.5 19.25V6.75C25.5 6.08594 24.9141 5.5 24.25 5.5ZM24.25 19.25H16.75V6.75H24.25V19.25ZM4.25 1.75H19.25V4.25H20.5V1.75C20.5 1.08594 19.9141 0.5 19.25 0.5H4.25C3.54688 0.5 3 1.08594 3 1.75V11.75H1.125C0.773438 11.75 0.5 12.0625 0.5 12.375V13C0.5 14.4062 1.59375 15.5 2.96094 15.5H14.25V14.25H2.96094C2.29688 14.25 1.75 13.7031 1.75 13H14.25V11.75H4.25V1.75Z",
    fill: "#666666"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeviceManage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/device_manage.e6a11977.svg";
export { ForwardRef as ReactComponent };